import React, { useEffect, useState, useRef } from 'react';
import { Col, Container, Row, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TextInput from 'src/Components/GenericInputText/TextInput';
import { BackAvatarSVG, SearchSVG } from '../../../../img/GlobalSVG';
import RecentSearch from '../RecentSearch';
import './AllServiceRequest.scss';

const AllServiceRequest = () => {
  const pageInfo = useRef(null);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <div className="allServiceRequestWrapper all-request-admin">
      <Container className="p-0">
        <div
          className="sr-only"
          role="heading"
          aria-level={1}
          tabIndex={0}
          ref={pageInfo}
        >
          {' '}
          Service Request Page
        </div>
        <div className="d-flex align-items-center">
          <div className="mt-3">
            <Link
              to="/admin/price-compare"
              aria-label="Go back to price compare search page"
            >
              <BackAvatarSVG.BackArrowSVG />
            </Link>
          </div>
          <div className="ml-3">
            <h1 className="content-header" aria-hidden={true}>
              <span className="content-header-bold">Service</span> Request(s)
            </h1>
          </div>
        </div>
      </Container>
      <div className="documents-filter-container filter-bar-border-top filter-bar-border-bottom mt-2 mb-md-4 mb-xs-3">
        <Container className="p-0">
          <Row className="justify-content-between">
            <Col xs={8} sm={6} md={3} className=" border-right-documents py-3">
              <label htmlFor="filterByTitleReference" className="sr-only">
                Search by title and reference
              </label>
              <TextInput
                parentClassName="document-search"
                append={
                  <InputGroup.Text>
                    <SearchSVG.SearchSVG className="primary-text-color" />
                  </InputGroup.Text>
                }
                inputProps={{
                  type: 'text',
                  placeholder: 'Search',
                  className: 'border-0 height-32',
                  value: searchText,
                  onChange: onSearch,
                  id: 'filterByTitleReference',
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="p-0">
        <div>
          <RecentSearch showingResultItem={10} searchText={searchText} />
        </div>
      </Container>
    </div>
  );
};

export default AllServiceRequest;
